import React from 'react';
import Items from '../StockOperation/Items';

export default Items;